/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Copy } from 'lucide-react';
import { Check } from 'lucide-react';
import React, { useState } from 'react';
import { green } from 'sushiweb/tokens/color';

const CopyElement = ({
  title,
  titleText,
  className,
  showTitle = true,
  position = 'bottom',
}) => {
  const [isCopied, setIsCopied] = useState(false);

  return (
    <div
      onClick={(e) => {
        e?.stopPropagation();
        setIsCopied(true);
        if (
          navigator &&
          navigator.clipboard &&
          typeof navigator.clipboard.writeText === 'function'
        ) {
          navigator.clipboard.writeText(titleText);
        }
        setTimeout(() => {
          setIsCopied(false);
        }, 1000);
      }}
      className={`tw-cursor-pointer tw-flex tw-text-center tw-gap-2 tw-h-full tw-relative`}
    >
      <span className={`${className}`}>{showTitle ? title : null}</span>
      <span className='tw-flex tw-items-center tw-relative tw-w-6'>
        <Copy
          size={14}
          color={green.z700}
          className={`tw-transition-all tw-absolute tw-duration-300 tw-ease-out ${
            isCopied ? 'tw-opacity-0' : 'tw-opacity-100'
          }`}
        />
        <Check
          size={16}
          color='#318616'
          className={`tw-transition-all tw-absolute tw-duration-300 tw-ease-out ${
            isCopied
              ? 'tw-opacity-100 tw-scale-100'
              : 'tw-opacity-0 tw-scale-75'
          }`}
        />
      </span>
      {isCopied && (
        <div
          className={`tw-shadow tw-absolute tw-z-50 ${
            position === 'right'
              ? 'tw-ml-40 tw-top-1/2 -tw-translate-y-1/2'
              : '-tw-right-9 tw-top-0 tw-mt-16'
          } tw-whitespace-nowrap tw-rounded-xl tw-font-medium tw-text-white tw-bg-base-green tw-px-3 tw-py-[0.8rem] tw-text-[1.3rem] tw-leading-none tw-w-fit`}
        >
          Copied!
        </div>
      )}
    </div>
  );
};

export default CopyElement;
